const footerGrayscale = {
	el: {
		footerLogo: $('.footer__top__logos__footer-logo'),
	},
	events() {
		this.el.footerLogo.hover(e => $(e.currentTarget).find('.grayscale').toggleClass('grayscale-off'));
	},
	init() {
		this.events();
	}
}

footerGrayscale.init();